.footer {
  --sd-app-footer-padding-inline: 5%;
  --sd-app-footer-max-inline-size: 100rem;
  --sd-app-footer-links-column-width: 12rem;
}
